import { createFileRoute } from '@tanstack/react-router'

import CompanyPage from '@/features/companies/pages/customer/company'

export const Route = createFileRoute('/_shell/company')({ component: CompanyPage })
